module.exports = __webpack_public_path__ + "img/radio-pahang.9e046615.jpg";